import React, { useState, useEffect } from 'react';
import styles from '../../GameBoard/GameBoard.module.scss';
import CursorSVG from './cursor.svg';
import { useViewSize } from '@/providers/ViewSizeContext';
import { useClientMount } from '@/providers/ClientMountProvider';

interface CustomCursorProps {
  x: number;
  y: number;
  visible: boolean;
}

export const CustomCursor: React.FC<CustomCursorProps> = ({ x, y, visible }) => {
  // SSR guards
  const { isReady: isViewSizeReady } = useViewSize();
  const { mounted } = useClientMount();

  if (!mounted || !isViewSizeReady || !visible) return null;

  return (
    <div
      className={styles['custom-cursor']}
      style={{
        left: `${x}px`,
        top: `${y}px`
      }}
    >
      <CursorSVG />
    </div>
  );
};
